import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  IonicPage,
  ModalController,
  PopoverController,
  Events,
  AlertController,
} from "ionic-angular";
import { Auth } from "./../../providers/auth/auth";

import { CompanyAnalysis } from "../../models/company-analysis.model";
import { Observable } from "rxjs/Observable";
import * as CompanyAnalysisActions from "../../actions/company-analysis.actions";
import * as AppActions from "../../actions/app.actions";
import { Sector } from "../../models/sector";
import { Region } from "../../models/region";
import { Subscription } from "rxjs/Subscription";
import { distinctUntilChanged } from "rxjs/operators";

import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";

const sortBy = require("lodash/sortBy"); // tslint:disable-line

import * as mm from "micromongo";
import * as users from "../../actions/user.actions";
import { Title } from "@angular/platform-browser";
@IonicPage({
  priority: "high",
  segment: "home",
})
@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  public tickers = ["ACA-GB", "MMM-US"];
  public level: string = "sector";
  sectors: Observable<Sector[]>;
  regions: Observable<Region[]>;
  industries: any;

  companyAnalysis: Observable<CompanyAnalysis>;
  companyAnalysisUpper: Observable<any>;
  companyAnalysisLower: Observable<any>;

  companyAnalysisConfigUpper: any = {
    name: "Top 5",
    ref: "upper",
    screens: {},
    defaultColumns: [
      "ticker",
      "name",
      "priceChangePercent",
      "priceChange",
      "ebitMarginExpectation",
      "yearThreeConsensusGrowth",
    ],
    userColumns: null,
    config: {
      ref: "upper",
      limit: 5,
      sort: {
        priceChangePercent: -1,
      },
    },
  };
  companyAnalysisConfigLower: any = {
    name: "Bottom 5",
    ref: "lower",
    screens: {},
    defaultColumns: [
      "ticker",
      "name",
      "priceChangePercent",
      "priceChange",
      "ebitMarginExpectation",
      "yearThreeConsensusGrowth",
    ],
    userColumns: null,
    config: {
      ref: "lower",
      limit: 5,
      sort: {
        priceChangePercent: 1,
      },
    },
  };

  wwPlatform: Observable<any>;
  loadingUpper: boolean = true;
  loadingLower: boolean = true;
  subUpper: any;
  subLower: any;

  sector: string;
  industry: string;
  region: string;
  sectorsSubscription: Subscription = null;
  authUserSubscription: Subscription = null;
  _sectors: any;

  public companies$: Observable<any>;
  public filterUpper$: Observable<any>;
  public filterLower$: Observable<any>;

  constructor(
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public store: Store<fromRoot.State>,
    public eventsCtrl: Events,
    public modalCtrl: ModalController,
    public authProvider: Auth,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public title: Title
  ) {
    this.title.setTitle(`Willis Welby`);

    this.sectors = this.store.select(fromRoot.getSectors);
    this.regions = this.store.select(fromRoot.getRegions);

    this.filterUpper$ = this.store
      .select(fromRoot.getUpperFilter)
      .filter((v) => {
        return v !== undefined;
      })
      .pipe(distinctUntilChanged());
    this.filterLower$ = this.store
      .select(fromRoot.getLowerFilter)
      .filter((v) => {
        return v !== undefined;
      })
      .pipe(distinctUntilChanged());

    this.companies$ = this.store
      .select(fromRoot.getCompanies)
      .filter((v) => v.length > 0)
      .pipe(distinctUntilChanged());

    this.companyAnalysisUpper = this.filterUpper$.combineLatest(
      this.companies$,
      (filter: any, results: Array<any>) => {
        this.companyAnalysisConfigUpper = filter;
        let analysis = {
          ...filter,
          ...{ results: mm.find(results, filter.screens || {}) },
        };
        if (filter.config && filter.config.limit) {
          analysis.results.sort(
            (n1, n2) => n2.priceChangePercent - n1.priceChangePercent
          );
          analysis.results = analysis.results.slice(0, filter.config.limit);
        }
        return analysis;
      }
    );

    this.companyAnalysisLower = this.filterLower$.combineLatest(
      this.companies$,
      (filter: any, results: Array<any>) => {
        this.companyAnalysisConfigLower = filter;
        let analysis = {
          ...filter,
          ...{ results: mm.find(results, filter.screens || {}) },
        };
        if (filter.config && filter.config.limit) {
          analysis.results.sort(
            (n1, n2) => n1.priceChangePercent - n2.priceChangePercent
          );
          analysis.results = analysis.results.slice(0, filter.config.limit);
        }
        return analysis;
      }
    );
  }

  ionViewDidEnter() {
    this.store.dispatch(new AppActions.SetPage("home"));

    // Wait for auth before subscribig to avoid 401s
    this.authProvider.authUser
      .first((jwt) => !!jwt)
      .take(1)
      .subscribe((jwt) => {
        if (jwt) {
          this.subscribeToStores();
          // this.fetchData(this.sector, this.industry, this.region);
        }
      });
    // this.eventsCtrl.publish('openSidebar', 'home');
  }
  ngOnDestroy() {
    if (this.sectorsSubscription !== null)
      this.sectorsSubscription.unsubscribe();
    if (this.authUserSubscription !== null)
      this.authUserSubscription.unsubscribe();
  }

  subscribeToStores() {
    this.wwPlatform = this.store.select(fromRoot.getPlatformInfo);
    this.sectors = this.store.select(fromRoot.getSectors);
    this.regions = this.store.select(fromRoot.getRegions);
  }

  goCompanyContainerPage(ticker) {
    this.navCtrl.push("CompanyContainerPage", { ticker });
  }

  updateFilter(filter) {
    this.store.dispatch(new users.UpdateFilter({ filter }));
  }
}

function isEmpty(val) {
  let lreturn: boolean;

  if (val == 0) lreturn = false;
  lreturn =
    isNaN(val) || val === undefined || val == null || val.length <= 0
      ? true
      : false;
  return lreturn;
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts